export default {
    // 監控面板
    dashboardTimeRangeType: {
        REQUEST_SUMMARY: "requestSummary",
        SAMPLING: "sampling",
        REPORT: "report",
    },
    // RcmTable_v2 通用
    ES_SEARCH_MAX_SIZE: 10000,
    MAX_CERT_DOWNLOAD_NUMBER: 3000,
    // 域名物件
    exportAppProfileType: {
        APP_PROFILE_DOMAIN: "exportAppProfileDomain",
        APP_PROFILE: "exportAppProfile",
    },
    PROXY_SET_HEADER_SYSTEM_OPTIONS: [
        "CDN-Request-ID",
        "CDN-IP-Location",
        "CDN-Internet-Service-Provider",
        "CDN-JA3",
        "CDN-JA3-Hash",
        "CDN-JA4"
    ],
    WAF_SET_REQ_HEADERS_PROHIBITED_KEYS: [
        "x-forwarded-for",
        "x-forwarded-proto",
        "true-client-ip",
        "rid",
        "c-type",
        "host",
        "connection",
        "if-modified-since",
        "if-unmodified-since",
        "if-match",
        "if-none-match",
        "user-agent",
        "referer",
        "content-length",
        "content-range",
        "content-type",
        "range",
        "if-range",
        "transfer-encoding",
        "te",
        "expect",
        "upgrade",
        "accept-encoding",
        "via",
        "authorization",
        "keep-alive",
        "x-forwarded-for",
        "x-real-ip",
        "accept",
        "accept-language",
        "depth",
        "destination",
        "overwrite",
        "date",
        "cookie",
        // "cdn-loop",
        "cdn-connecting-ip",
    ],
    // WAF 規則
    WAF_DETECT_KEYS: [
        "wafIp",
        "wafUri",
        "wafHeaders",
        "wafHeadersExist",
        "wafCountry",
        "wafIsp",
        "wafProxyType",
        "wafJa3Hashes",
        "wafHttpMethod",
        "wafRateLimit",
    ],
    WAF_URI_OR_HEADERS_SYSTEM_VARIABLES: ["host", "request_uri", "rip", "dstport", "scheme", "rootdomain"],
    WAF_PROXY_TYPE_KEYS: ["VPN", "TOR", "DCH", "PUB", "WEB", "SES"],
    WAF_HTTP_METHOD_KEYS: ["GET", "POST", "PURGE", "PUT", "HEAD", "OPTIONS", "DELETE", "PATCH"],
    WAF_JA3_JA4_SYSTEM_RESERVED_VALUE: "NOT EXIST",
    // 回源政策
    customSetting: {
        hostHeaderType: {
            FOLLOW_FQDN: "followFQDN",
            REQUEST_HOST: "requestHost",
            CUSTOM: "custom",
        },
        portMappingType: {
            DEFAULT: "default",
            STATIC: "static",
        },
    },
    // EDGE 管理、群組資源
    customDefaultCertApplyRule: {
        FOLLOW_GROUP: "followGroup",
        EDGE_SPECIFIC: "edge",
        NONE: "none",
    },
};



// WEBPACK FOOTER //
// ./src/libs/enumList.js